import { type ComponentType } from 'react';
import PlaceholderComponent from '../../placeholder/placeholder.component';
import { type Props } from './leaflet-map.component';
import dynamic from 'next/dynamic';
const MOBILE_MAP_HEIGHT = 217;
const DESKTOP_MAP_HEIGHT = '100vh';
export const DynamicLeafletMapComponent: ComponentType<Props> = dynamic(() => import('./leaflet-map.component'), {
  ssr: false,
  loading: () => <PlaceholderComponent id={'leaflet-map-placeholder'} heightSinceWidth={[{
    sinceWidth: 0,
    height: MOBILE_MAP_HEIGHT
  }, {
    sinceWidth: 1024,
    height: DESKTOP_MAP_HEIGHT
  }]} />
});